import { Lock } from '../../../components/ui/icons';
import type { Round } from '@h2h/shared';
import { cn } from '../../../lib/cn';
import { relativeDay } from '../helpers';

export function SlatePager({
  rounds,
  selectedId,
  isCycling,
  now,
  onSelect,
  embedded = false
}: {
  rounds: Round[];
  selectedId: string | null;
  isCycling: boolean;
  now: number;
  onSelect: (roundId: string) => void;
  /** Inside the play card — tighter padding, no top margin. */
  embedded?: boolean;
}) {
  return (
    <div
      className={
        embedded
          ? 'flex gap-1.5 overflow-x-auto px-[18px] pb-3 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'
          : 'flex gap-2 overflow-x-auto pb-0 pt-4 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'
      }
    >
      {rounds.map((r) => {
        const active = r.roundId === selectedId;
        const locked = r.status === 'SCHEDULED';
        const label = isCycling ? r.label : relativeDay(r.firstKickoffAt, now);
        return (
          <button
            key={r.roundId}
            type="button"
            onClick={() => onSelect(r.roundId)}
            className={cn(
              'tap flex shrink-0 items-center gap-[5px] rounded-[13px] px-4 py-[9px] text-[13px] tracking-snug',
              active
                ? 'bg-night font-bold text-white'
                : locked
                  ? 'bg-[#F6F6F9] font-semibold text-[#B4B4BC]'
                  : 'bg-fill font-semibold text-ink2'
            )}
          >
            {locked && (
              <Lock width={11} height={11} strokeWidth={2.4} className={active ? 'text-white/70' : 'text-[#B4B4BC]'} />
            )}
            {label}
          </button>
        );
      })}
    </div>
  );
}
